<template>
    <div class="busqueda-avanzada-component d-flex align-items-center position-relative" ref="rootEl">

        <!-- Ícono solo en móviles -->
        <i class="bx bx-search-alt d-inline d-md-none" :title="buttonTitle" @click.stop="panelOpen = !panelOpen"
            style="color: white!important;"></i>

        <!-- Botón desktop -->
        <button type="button" class="btn btn-vehiculo d-none d-md-flex align-items-center gap-2" :title="buttonTitle"
            style="color: white!important;" @click.stop="panelOpen = !panelOpen">
            <span v-html="buttonText"></span>
        </button>

        <!-- PANEL -->
        <div v-show="panelOpen" class="position-absolute" style="top:100%; left:0; z-index:5000;" @click.stop>

            <div class="modal-dialog modal-debajo-boton">
                <div class="modal-content bg-dark-app text-white border-0"
                    style="border-radius:25px; overflow:hidden; min-height: 400px;">

                    <!-- MENU -->
                    <div v-if="currentStep === 'menu'" class="modal-body p-4">

                        <div class="d-flex justify-content-between align-items-center mb-4">
                            <span class="small text-uppercase fw-bold">
                                <i class="bx bx-car me-1"></i>Búsquedas
                            </span>
                            <button class="btn-close btn-close-white" @click.stop="panelOpen = false"></button>
                        </div>

                        <div v-if="activeSearchVehicle"
                            class="selection-active-card mb-4 p-3 d-flex align-items-center gap-3" @click.stop>
                            <i class="bx bxs-check-circle text-success fs-2"></i>
                            <div>
                                <h6 class="mb-0 fw-bold text-white">
                                    <!--{{ activeSearchVehicle.year }}-->
                                    {{ activeSearchVehicle.marca }}
                                    <!--{{ activeSearchVehicle.modelo }}-->
                                </h6>
                                <!--<small class="text-success">Seleccionado para búsqueda</small>-->
                                <small class="text-success">Vehículo de referencia</small>
                            </div>
                        </div>

                        <h4 class="fw-bold mb-4">¿Cómo quieres buscar hoy?</h4>

                        <div class="row g-3 mb-4">
                            <div class="col-12">
                                <div class="search-option-card p-3 h-100" @click.stop="currentStep = 'form_vehiculo'">
                                    <div class="icon-box-dark mb-2">
                                        <i class="bx bx-car fs-3"></i>
                                    </div>
                                    <span class="fw-bold small">Por Vehículo</span>
                                </div>
                            </div>
                            <!--<div class="col-6">
                                <div class="search-option-card p-3 h-100" @click.stop="seleccionarMedidas">
                                    <div class="icon-box-dark mb-2">
                                        <i class="bx bx-ruler fs-3"></i>
                                    </div>
                                    <span class="fw-bold small">Por Medidas</span>
                                </div>
                            </div>-->
                        </div>

                        <hr class="border-secondary opacity-25 my-4">

                        <div class="garage-section" @click.stop>
                            <div class="d-flex justify-content-between mb-3">
                                <h5 class="fw-bold mb-0">Mi Garage</h5>
                                <span class="badge bg-dark">{{ garage.length }}</span>
                            </div>

                            <div v-if="!garage.length" class="text-center p-4 border rounded">
                                <p class="small mb-0">
                                    Aún no tienes vehículos guardados.
                                </p>
                            </div>

                            <div v-else class="garage-scroll-container px-1"
                                style="max-height: 250px; overflow-y: auto;">
                                <div v-for="g in garage" :key="g.id" class="garage-item-card mb-3 p-3 position-relative"
                                    @click.stop>
                                    <button class="btn-delete-garage" @click.stop="confirmarEliminarVehiculo(g)"
                                        title="Eliminar vehículo"> <i class="bx bx-x"></i> </button>
                                    <div class="d-flex align-items-center gap-3">
                                        <div class="garage-icon-box"> <i class="bx bx-car fs-4"></i> </div>
                                        <div
                                            class="flex-grow-1 d-flex align-items-center justify-content-between gap-3 p-3">
                                            <h6 class="mb-0 fw-bold text-white small text-nowrap">{{ g.marca }}</h6>

                                            <div class="d-flex align-items-center">
                                                <div class="form-check form-switch m-0 d-flex align-items-center gap-2">
                                                    <input class="form-check-input custom-switch" type="checkbox"
                                                        role="switch" :id="'def-' + g.id" :checked="g.is_default"
                                                        @change.stop="toggleDefault(g.id)">
                                                    <label class="form-check-label x-small text-white-50"
                                                        :for="'def-' + g.id">Favorito</label>
                                                </div>
                                            </div>
                                            <!--<h6 class="mb-1 fw-bold text-white small">{{ g.year }} {{ g.marca }} {{
                                                g.modelo }}</h6>
                                            <div class="d-flex align-items-center gap-3 mt-2">
                                                <button class="btn btn-sm btn-select-garage"
                                                    @click.stop="applyGarageItem(g)">
                                                    {{ (selectedModelo === g.modelo && selectedYear === g.year) ?
                                                        'Activo' : 'Seleccionar' }}
                                                    {{ (selectedMarca === g.marca) ?
                                                        'Activo' : 'Seleccionar' }}
                                                </button>
                                                <div class="form-check form-switch m-0 d-flex align-items-center gap-2">
                                                    <input class="form-check-input custom-switch" type="checkbox"
                                                        role="switch" :id="'def-' + g.id" :checked="g.is_default"
                                                        @change.stop="toggleDefault(g.id)">
                                                    <label class="form-check-label x-small"
                                                        :for="'def-' + g.id">Favorito</label>
                                                </div>
                                            </div>
                                            -->
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <router-link v-if="isLoggedin" :to="{ path: '/dashboard', query: { section: 'garage' } }"
                                class="d-flex justify-content-between align-items-center mb-3 text-decoration-none text-light-emphasis">
                                <h5 class="fw-bold mb-0">Ir a mi garage</h5>
                                <i class="bx bx-chevron-right fs-4"></i>
                            </router-link>

                        </div>
                    </div>

                    <!-- FORM VEHICULO -->
                    <div v-else-if="currentStep === 'form_vehiculo'" class="modal-body p-4" @click.stop>

                        <div class="mb-3 d-flex align-items-center" @click.stop="currentStep = 'menu'"
                            style="cursor:pointer">
                            <i class="bx bx-left-arrow-alt fs-3"></i>
                            <span class="ms-2">Volver</span>
                        </div>

                        <h5 class="fw-bold text-white mb-3 text-uppercase">Agregar Vehículo</h5>
                        <p class="small mb-3">1. Seleccione los detalles:</p>

                        <!-- Layout dos columnas -->
                        <div class="vehiculo-layout-horizontal">

                            <!-- Columna izquierda: botones -->
                            <div class="vehiculo-col-left">
                                <!-- Año -->
                                <div class="hfield-row" :class="{ active: activeDropdown === 'year' }">
                                    <button class="hfield-btn w-100" :class="{ 'has-value': selectedYear }"
                                        @click.stop="toggleActiveDropdown('year')"
                                        :disabled="isLoading || !years.length">
                                        <span>{{ selectedYear || 'Año' }}</span>
                                        <i class="bx bx-chevron-right"></i>
                                    </button>
                                </div>

                                <!-- Marca -->
                                <div class="hfield-row" :class="{ active: activeDropdown === 'marca' }">
                                    <button class="hfield-btn w-100" :class="{ 'has-value': selectedMarca }"
                                        @click.stop="toggleActiveDropdown('marca')"
                                        :disabled="isLoadingMarcas || !marcas.length">
                                        <span>{{ selectedMarca || 'Marca' }}</span>
                                        <i class="bx bx-chevron-right"></i>
                                    </button>
                                </div>

                                <!-- Modelo -->
                                <div class="hfield-row" :class="{ active: activeDropdown === 'modelo' }">
                                    <button class="hfield-btn w-100" :class="{ 'has-value': selectedModelo }"
                                        @click.stop="toggleActiveDropdown('modelo')"
                                        :disabled="isLoadingModelo || !modelos.length">
                                        <span>{{ selectedModelo || 'Modelo' }}</span>
                                        <i class="bx bx-chevron-right"></i>
                                    </button>
                                </div>

                                <!-- Motor -->
                                <div class="hfield-row" :class="{ active: activeDropdown === 'motor' }">
                                    <button class="hfield-btn w-100" :class="{ 'has-value': selectedMotor }"
                                        @click.stop="toggleActiveDropdown('motor')"
                                        :disabled="isLoadingMotor || !motores.length">
                                        <span>{{ selectedMotor || 'Motor' }}</span>
                                        <i class="bx bx-chevron-right"></i>
                                    </button>
                                </div>

                                <!-- Línea -->
                                <div class="hfield-row" :class="{ active: activeDropdown === 'linea' }">
                                    <button class="hfield-btn w-100" @click.stop="toggleActiveDropdown('linea')"
                                        :disabled="isLoadingLineas || !lineas.length">
                                        <span>{{ selectedLineaName || 'Línea' }}</span>
                                        <i class="bx bx-chevron-right"></i>
                                    </button>
                                </div>

                                <!-- Check guardar (solo invitados) 
                                <div v-if="!isLoggedin" class="form-check mt-3 px-1">
                                    <input class="form-check-input" type="checkbox" id="guardarVehiculo"
                                        v-model="guardarVehiculo">
                                    <label class="form-check-label small" for="guardarVehiculo">
                                        ¿Guardar este vehículo?
                                    </label>
                                </div>-->
                            </div>

                            <!-- Columna derecha: lista activa -->
                            <div class="vehiculo-col-right">

                                <!-- Estado vacío -->
                                <div v-if="!activeDropdown" class="hpanel-empty">
                                    <i class="bx bx-list-ul fs-2 mb-2 text-warning opacity-50"></i>
                                    <p class="small text-white-50 mb-0">Selecciona un campo<br>para ver las opciones</p>
                                </div>

                                <!-- Lista años -->
                                <template v-if="activeDropdown === 'year'">
                                    <div class="hpanel-search">
                                        <i class="bx bx-search"></i>
                                        <input v-model="filterYear" type="text" placeholder="Buscar año..."
                                            @click.stop />
                                    </div>
                                    <ul class="hpanel-list">
                                        <li v-if="!filteredYears.length" class="hpanel-empty-item">Sin resultados</li>
                                        <li v-for="year in filteredYears" :key="year" class="hpanel-item"
                                            :class="{ selected: selectedYear === year }" @click.stop="selectYear(year)">
                                            {{ year }}
                                            <i v-if="selectedYear === year" class="bx bx-check ms-auto"></i>
                                        </li>
                                    </ul>
                                </template>

                                <!-- Lista marcas -->
                                <template v-if="activeDropdown === 'marca'">
                                    <div class="hpanel-search">
                                        <i class="bx bx-search"></i>
                                        <input v-model="filterMarca" type="text" placeholder="Buscar marca..."
                                            @click.stop />
                                    </div>
                                    <ul class="hpanel-list">
                                        <li v-if="!filteredMarcas.length" class="hpanel-empty-item">Sin resultados</li>
                                        <li v-for="marca in filteredMarcas" :key="marca" class="hpanel-item"
                                            :class="{ selected: selectedMarca === marca }"
                                            @click.stop="selectMarca(marca)">
                                            {{ marca }}
                                            <i v-if="selectedMarca === marca" class="bx bx-check ms-auto"></i>
                                        </li>
                                    </ul>
                                </template>

                                <!-- Lista modelos -->
                                <template v-if="activeDropdown === 'modelo'">
                                    <div class="hpanel-search">
                                        <i class="bx bx-search"></i>
                                        <input v-model="filterModelo" type="text" placeholder="Buscar modelo..."
                                            @click.stop />
                                    </div>
                                    <ul class="hpanel-list">
                                        <li v-if="!filteredModelos.length" class="hpanel-empty-item">Sin resultados</li>
                                        <li v-for="modelo in filteredModelos" :key="modelo" class="hpanel-item"
                                            :class="{ selected: selectedModelo === modelo }"
                                            @click.stop="selectModelo(modelo)">
                                            {{ modelo }}
                                            <i v-if="selectedModelo === modelo" class="bx bx-check ms-auto"></i>
                                        </li>
                                    </ul>
                                </template>

                                <!-- Lista motores -->
                                <template v-if="activeDropdown === 'motor'">
                                    <ul class="hpanel-list">
                                        <li v-if="!motores.length" class="hpanel-empty-item">Sin resultados</li>
                                        <li v-for="motor in motores" :key="motor" class="hpanel-item"
                                            :class="{ selected: selectedMotor === motor }"
                                            @click.stop="selectMotor(motor)">
                                            {{ motor }}
                                            <i v-if="selectedMotor === motor" class="bx bx-check ms-auto"></i>
                                        </li>
                                    </ul>
                                </template>

                                <!-- Lista líneas -->
                                <template v-if="activeDropdown === 'linea'">
                                    <div class="hpanel-search">
                                        <i class="bx bx-search"></i>
                                        <input v-model="filterLinea" type="text" placeholder="Buscar línea..."
                                            @click.stop />
                                    </div>
                                    <ul class="hpanel-list">
                                        <li v-if="!filteredLineas.length" class="hpanel-empty-item">Sin resultados</li>
                                        <li v-for="linea in filteredLineas" :key="linea.id" class="hpanel-item"
                                            :class="{ selected: selectedLinea === linea.id }"
                                            @click.stop="selectLinea(linea)">
                                            {{ linea.name }}
                                            <i v-if="selectedLinea === linea.id" class="bx bx-check ms-auto"></i>
                                        </li>
                                    </ul>
                                </template>

                            </div>
                        </div>

                        <!-- Botones acción -->
                        <!-- Botones acción — siempre visible -->
                        <div class="vehiculo-actions">
                            <button type="button" class="btn btn-apply-orange w-100 py-3 fw-bold mb-2"
                                @click.stop="buscar" :disabled="isSearchDisabled">
                                Aplicar Filtro
                            </button>
                            <button type="button" class="btn btn-link w-100" @click.stop="limpiarSeleccion">
                                Limpiar selección
                            </button>
                        </div>
                    </div>

                    <!-- FORM MEDIDAS -->
                    <div v-else-if="currentStep === 'form_medidas'" class="modal-body p-4" @click.stop>

                        <div class="mb-3 d-flex align-items-center" @click.stop="currentStep = 'menu'"
                            style="cursor:pointer">
                            <i class="bx bx-left-arrow-alt fs-3"></i>
                            <span class="ms-2">Volver</span>
                        </div>

                        <div class="container-fluid p-0">
                            <h5 class="fw-bold mb-4">Buscar por medidas</h5>
                            <div class="row g-3">
                                <div class="col-12">
                                    <div class="mb-4">
                                        <label class="small mb-2">1. Seleccionar Línea:</label>
                                        <div class="dropdown w-100">
                                            <div class="dropdown-btn w-100 d-flex justify-content-between align-items-center p-3"
                                                @click.stop="dropdownOpenLineaMedidas = !dropdownOpenLineaMedidas">
                                                <span>{{ selectedLineaMedidas ? selectedLineaMedidas.name : '[Selecciona una línea]'
                                                    }}</span>
                                                <i class="bx bx-chevron-down"></i>
                                            </div>
                                            <ul v-show="dropdownOpenLineaMedidas" class="dropdown-menu-custom"
                                                @click.stop>
                                                <li v-for="linea in lineasmedidas" :key="linea.id" class="dropdown-item"
                                                    @click.stop="seleccionarLineaMedidas(linea)">
                                                    {{ linea.name }}
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row g-3 mb-4" v-if="medidasLinea.length">
                                <div v-for="(medida, index) in medidasLinea" :key="medida.id" class="col-12 mb-3">
                                    <label class="small fw-bold mb-2 d-block">
                                        {{ medida.name }} <span class="text-muted">({{ medida.unidad }})</span>
                                    </label>
                                    <select class="form-select input-measure-dark" v-model="medidaValores[medida.id]"
                                        @change="actualizarOpcionesDependientes(medida.id)"
                                        :disabled="cargandoOpciones">
                                        <option :value="undefined" disabled selected>
                                            -- Selecciona {{ medida.name }} --
                                        </option>
                                        <option v-for="valor in opcionesDinamicas[medida.id]" :key="valor"
                                            :value="valor">
                                            {{ valor }} {{ medida.unidad }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </div>

                        <div class="d-flex gap-2 mt-4">
                            <button class="btn btn-outline-secondary w-50 py-3 fw-bold" @click.stop="resetearMedidas"
                                :disabled="cargandoOpciones || !Object.keys(medidaValores).length">
                                Limpiar
                            </button>
                            <button class="btn btn-apply-orange w-100 py-3 fw-bold"
                                :disabled="cargandoOpciones || !Object.keys(medidaValores).length"
                                @click.stop="buscarPorMedidas">
                                <span v-if="cargandoOpciones" class="spinner-border spinner-border-sm me-2"></span>
                                {{ cargandoOpciones ? 'Actualizando...' : 'Aplicar Medidas' }}
                            </button>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ParametrizacionBusquedaAvanzada",
    data() {
        return {
            isLoggedin: window.Laravel ? window.Laravel.isLoggedin : false,

            panelOpen: false,

            selectedYear: null,
            selectedMarca: null,
            selectedModelo: null,
            selectedMotor: null,
            selectedLinea: null,

            isLoading: false,
            isLoadingMarcas: false,
            isLoadingModelo: false,
            isLoadingMotor: false,
            isLoadingLineas: false,

            years: [],
            marcas: [],
            modelos: [],
            motores: [],
            lineas: [],
            busqueda: [],
            activeDropdown: null,
            loadingFlags: {
                marcas: false,
                modelos: false,
                motores: false,
                motoresLineas: false
            },
            garageKey: "mi_garage",
            garageLimit: 3,
            currentStep: 'menu',
            guardarVehiculo: false,
            lineasmedidas: [],           // líneas que vienen del backend
            selectedLineaMedidas: null,  // línea seleccionada por el usuario
            dropdownOpenLineaMedidas: false,
            medidasLinea: [],   // ← array de medidas dinámicas
            medidaValores: {},
            opcionesDinamicas: {},
            cargandoOpciones: false,
            medidasLineaOriginales: [],
            filterYear: '',
            filterMarca: '',
            filterModelo: '',
            filterLinea: '',
        };
    },

    computed: {
        filteredYears() {
            if (!this.filterYear) return this.years;
            return this.years.filter(y => String(y).includes(this.filterYear));
        },
        filteredMarcas() {
            if (!this.filterMarca) return this.marcas;
            return this.marcas.filter(m => m.toLowerCase().includes(this.filterMarca.toLowerCase()));
        },
        filteredModelos() {
            if (!this.filterModelo) return this.modelos;
            return this.modelos.filter(m => m.toLowerCase().includes(this.filterModelo.toLowerCase()));
        },
        filteredLineas() {
            if (!this.filterLinea) return this.lineas;
            return this.lineas.filter(l => l.name.toLowerCase().includes(this.filterLinea.toLowerCase()));
        },
        isSearchDisabled() {
            return !this.selectedYear || !this.selectedMarca || !this.selectedModelo;
        },

        selectedLineaName() {
            const l = this.lineas.find(linea => linea.id === this.selectedLinea);
            return l ? l.name : null;
        },

        defaultGarageItem() {
            return this.garage.find(g => g.is_default) || null;
        },

        buttonText() {
            const g = this.activeSearchVehicle;
            if (!g) return "Seleccionar vehículo";
            return `${g.marca}`;
        },

        shortButtonText() {
            const g = this.activeSearchVehicle;
            if (!g) return "Vehículo";
            //return `<strong>${g.marca}</strong> &nbsp;|&nbsp; <strong>${g.modelo}</strong>`;
            return `<strong>${g.marca}</strong>`;
        },

        buttonTitle() {
            return this.buttonText;
        },

        activeSearchVehicle() {
            return this.$store.getters.vehiculoSeleccionado;
        },
        garage() {
            return this.$store.getters.garageActivo || [];
        },
        selectedLineaName() {
            const linea = this.lineas.find(l => l.id === this.selectedLinea);
            return linea ? linea.name : null;
        }
    },

    methods: {
        toggleActiveDropdown(field) {
            this.activeDropdown = this.activeDropdown === field ? null : field;
            // Limpiar filtros al cambiar
            this.filterYear = '';
            this.filterMarca = '';
            this.filterModelo = '';
            this.filterLinea = '';
        },
        generarEscala(min, max) {
            const opciones = [];
            const inicio = Number(min);
            const fin = Number(max);
            // Ajusta el "paso" según el tamaño del rango
            // Si la diferencia es mucha, salta de 5 en 5 o 10 en 10
            const diferencia = fin - inicio;
            let paso = 1;
            if (diferencia > 100) paso = 10;
            else if (diferencia > 20) paso = 5;
            for (let i = inicio; i <= fin; i += paso) {
                opciones.push(i);
            }
            return opciones;
        },
        /* ================= PANEL ================= */
        setInitialYear() {
            if (!this.years || !this.years.length) return;

            const currentYear = new Date().getFullYear();

            // Si el año actual existe en el catálogo, usarlo
            this.selectedYear = this.years.includes(currentYear)
                ? currentYear
                : this.years[0];

            this.handleYearChange(); // carga marcas
        },

        openPanel() {
            this.panelOpen = true;
            this.limpiarSeleccion();
        },

        closePanel() {
            this.panelOpen = false;
            this.currentStep = 'menu';
            this.activeDropdown = null;
            //this.limpiarSeleccion();
            this.closeAllDropdowns();
        },

        resetPanelUI() {
            this.currentStep = 'menu';
            this.closeAllDropdowns();
        },

        handleClickOutside(e) {
            if (!this.panelOpen) return;

            // Si el clic está dentro del rootEl, no cerramos
            if (this.$refs.rootEl.contains(e.target)) return;

            // Clic fuera del componente => cerramos panel
            this.closePanel();
        },
        toggleDropdown(which) {
            const map = {
                year: { key: 'dropdownYearOpen', ref: 'wrapperYear', forceDown: true },
                marca: { key: 'dropdownMarcaOpen', ref: 'wrapperMarca', forceDown: true },
                modelo: { key: 'dropdownModeloOpen', ref: 'wrapperModelo', forceDown: false },
                motor: { key: 'dropdownMotorOpen', ref: 'wrapperMotor', forceDown: false },
                linea: { key: 'dropdownLineaOpen', ref: 'wrapperLinea', forceDown: false },
            };

            const { key, ref, forceDown } = map[which];
            if (!key) return;

            const isOpen = this[key];
            this.closeAllDropdowns();
            this[key] = !isOpen;

            if (!isOpen) {
                this.$nextTick(() => {
                    const wrapper = this.$refs[ref];
                    const container = this.$refs.scrollContainer;
                    if (!wrapper || !container) return;

                    if (forceDown) {
                        wrapper.classList.remove('dropup');
                        return;
                    }

                    const wrapperRect = wrapper.getBoundingClientRect();
                    const containerRect = container.getBoundingClientRect();
                    const espacioAbajo = containerRect.bottom - wrapperRect.bottom;

                    if (espacioAbajo < 220) {
                        wrapper.classList.add('dropup');
                    } else {
                        wrapper.classList.remove('dropup');
                    }
                });
            }
        },

        closeAllDropdowns() {
            this.dropdownYearOpen = false;
            this.dropdownMarcaOpen = false;
            this.dropdownModeloOpen = false;
            this.dropdownMotorOpen = false;
            this.dropdownLineaOpen = false;
            this.filterYear = '';
            this.filterMarca = '';
            this.filterModelo = '';
            this.filterLinea = '';
        },

        /* ================= SELECTS ================= */

        selectYear(year) {
            this.selectedYear = year;
            this.closeAllDropdowns();
            this.handleYearChange();
        },

        selectMarca(marca) {
            this.selectedMarca = marca;
            this.closeAllDropdowns();
            this.handleMarcaChange();
        },

        selectModelo(modelo) {
            this.selectedModelo = modelo;
            this.closeAllDropdowns();
            this.handleModeloChange();
        },

        selectMotor(motor) {
            this.selectedMotor = motor;
            this.closeAllDropdowns();
            this.handleMotoresLineasChange();
        },

        selectLinea(linea) {
            this.selectedLinea = linea.id;
            this.closeAllDropdowns();
            /*this.addToGarageIfNotExists({
                year: this.selectedYear,
                marca: this.selectedMarca,
                modelo: this.selectedModelo,
                motor: this.selectedMotor,
                //linea: this.selectedLinea
            });
            this.buscar();*/
        },

        /* ================= CARGAS ================= */

        handleYearChange() {
            this.selectedMarca = null;
            this.selectedModelo = null;
            this.selectedMotor = null;
            this.selectedLinea = null;
            this.modelos = [];
            this.motores = [];
            this.lineas = [];
            this.loadMarcas();
        },

        handleMarcaChange() {
            this.selectedModelo = null;
            this.selectedMotor = null;
            this.selectedLinea = null;
            this.modelos = [];
            this.motores = [];
            this.lineas = [];
            this.loadModelos();
        },

        handleModeloChange() {
            this.selectedMotor = null;
            this.selectedLinea = null;
            this.motores = [];
            this.lineas = [];
            this.loadMotores();
        },

        handleMotoresLineasChange() {
            this.isLoadingLineas = true;
            this.loadMotoresLineas();
        },

        loadMarcas() {
            if (this.loadingFlags.marcas) return;
            this.loadingFlags.marcas = true;
            this.isLoadingMarcas = true;

            axios.post(`/catalogo/loadmarcasnuevo`, { year: this.selectedYear })
                .then(res => this.marcas = res.data.marcas || [])
                .finally(() => {
                    this.isLoadingMarcas = false;
                    this.loadingFlags.marcas = false;
                });
        },

        loadModelos() {
            if (this.loadingFlags.modelos) return;
            this.loadingFlags.modelos = true;
            this.isLoadingModelo = true;

            axios.post(`/catalogo/loadmodelosnuevo`, {
                year: this.selectedYear,
                marca: this.selectedMarca
            }).then(res => {
                this.modelos = res.data.modelos || [];
                this.lineas = res.data.lineas || [];
            }).finally(() => {
                this.isLoadingModelo = false;
                this.loadingFlags.modelos = false;
            });
        },

        loadMotores() {
            if (this.loadingFlags.motores) return;
            this.loadingFlags.motores = true;
            this.isLoadingMotor = true;

            axios.post(`/catalogo/loadmotoresnuevo`, {
                year: this.selectedYear,
                marca: this.selectedMarca,
                modelo: this.selectedModelo
            }).then(res => {
                this.motores = res.data.motores || [];
                this.lineas = res.data.lineas || [];
            }).finally(() => {
                this.isLoadingMotor = false;
                this.loadingFlags.motores = false;
            });
        },

        loadMotoresLineas() {
            if (this.loadingFlags.motoresLineas) return;
            this.loadingFlags.motoresLineas = true;

            axios.post(`/catalogo/loadmotoreslineasnuevo`, {
                year: this.selectedYear,
                marca: this.selectedMarca,
                modelo: this.selectedModelo,
                motor: this.selectedMotor,
                linea: this.selectedLinea
            }).then(res => {
                if (!this.selectedMotor) this.motores = res.data.motores || [];
                if (!this.selectedLinea) this.lineas = res.data.lineas || [];
            }).finally(() => {
                this.isLoadingMotor = false;
                this.isLoadingLineas = false;
                this.loadingFlags.motoresLineas = false;
            });
        },

        /* ================= GARAGE ================= */

        loadGarageFromStorage() {
            if (this.isLoggedin) {
                this.garageKey = 'garage_operativo';
            }

            const raw = localStorage.getItem(this.garageKey);

            if (!raw) {
                this.garage = [];
                return;
            }

            const parsed = JSON.parse(raw);
            // Si está logeado, usar solo vehicles; si no, usar como está
            this.garage = this.isLoggedin && parsed.vehicles ? parsed.vehicles : parsed;
        },

        saveGarageToStorage() {
            localStorage.setItem(this.garageKey, JSON.stringify(this.garage));
        },

        keyOf(item) {
            //return `${item.year}|${item.marca}|${item.modelo}|${item.motor || ""}|${item.linea || ""}`;
            return `${item.marca}`;
        },

        addToGarageIfNotExists(item) {
            const k = this.keyOf(item);
            const idx = this.garage.findIndex(g => this.keyOf(g) === k);

            if (idx !== -1) {
                this.garage.push(this.garage.splice(idx, 1)[0]);
            } else {
                if (this.garage.length >= this.garageLimit) this.garage.shift();
                this.garage.push({
                    id: Date.now() + Math.random().toString(36).slice(2, 6),
                    ...item,
                    is_default: false
                });
            }

            this.$store.dispatch('addVehiculoToGarage', item);
        },

        /* ================= NAVEGACIÓN ================= */

        buscar() {
            const vehiculo = {
                //year: this.selectedYear,
                marca: this.selectedMarca,
                //modelo: this.selectedModelo,
                //motor: this.selectedMotor,
                //linea: this.selectedLinea
            }
            // Aquí delegamos toda la lógica de garage a Vuex / dispatch
            if (!this.isLoggedin && this.guardarVehiculo) {
                this.$store.dispatch('agregarVehiculoGarage', vehiculo);
                this.guardarVehiculo = false;
            }
            // 🌟 EXTRAEMOS SOLO EL ID SI ES UN OBJETO, O DEJAMOS EL VALOR CRUDO
            const idLineaQuery = this.selectedLinea && typeof this.selectedLinea === 'object'
                ? this.selectedLinea.id
                : this.selectedLinea;

            // Redirigir a resultados
            this.$router.push({
                name: "BusquedaAvanzada",
                query: {
                    year: this.selectedYear,
                    marca: this.selectedMarca,
                    modelo: this.selectedModelo,
                    motor: this.selectedMotor || 0,
                    linea: idLineaQuery || undefined
                }
            });

            this.closePanel();
        },

        toggleDefault(id) {
            const chosen = this.garage.find(g => g.id === id);
            if (!chosen) return;

            const garageOperativo = JSON.parse(localStorage.getItem('garage_operativo'));
            const esUsuarioLogeado = !!garageOperativo;
            /*Swal.fire({
                title: '¿Qué quieres hacer?',
                //text: `${chosen.marca} ${chosen.modelo} ${chosen.year}`,
                text: ` ${chosen.modelo}`,
                showCancelButton: true,
                confirmButtonText: 'Hacer predeterminado y buscar',
                cancelButtonText: 'Solo marcar como predeterminado'
            }).then(result => {
                if (result.isConfirmed) {
                    // Marcar como default y ejecutar búsqueda
                    
                    //this.saveGarageToStorage();
                    this.applyGaragePredeterminado(chosen, esUsuarioLogeado);
                    this.applyGarageItem(chosen); // aquí ejecuta buscar2
                } else {
                    // Solo marcar como predeterminado
                    
                    //this.saveGarageToStorage();
                    //this.applyGarageItem(chosen);
                    this.applyGaragePredeterminado(chosen, esUsuarioLogeado);
                }
            });*/
            Swal.fire({
                title: '¿Marcar como predeterminado?',
                text: `${chosen.modelo}`,
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: 'Marcar como predeterminado',
                cancelButtonText: 'Cancelar',
                confirmButtonColor: '#0d6efd',
            }).then(result => {
                if (result.isConfirmed) {
                    // Ejecuta solo la lógica de marcar como predeterminado
                    this.applyGaragePredeterminado(chosen, esUsuarioLogeado);

                    // Opcional: Una pequeña alerta de éxito para feedback del usuario
                    Swal.fire({
                        title: '¡Listo!',
                        text: 'Vehículo marcado como predeterminado',
                        icon: 'success',
                        timer: 1500,
                        showConfirmButton: false
                    });
                }
            });
        },
        async applyGaragePredeterminado(g, esUsuarioLogeado) {
            if (esUsuarioLogeado) {
                // Usuario logeado: backend + store
                try {
                    const { data } = await axios.post('/miGarageAdmin/vehiculos/default', {
                        vehiculo_id: g.id,
                        garage_id: g.garage_id
                    });

                    const garageActualizado = data.garage;

                    // Actualizar store y UI reactiva
                    this.$store.dispatch('setGarageOperativo', garageActualizado);

                } catch (e) {
                    console.error('Error actualizando predeterminado:', e);
                    await Swal.fire({
                        title: 'Error',
                        text: 'No se pudo actualizar el vehículo predeterminado.',
                        icon: 'error'
                    });
                }
            } else {
                // Invitado: solo UI local + localStorage + store
                const vehiclesActualizados = this.garage
                    .map(v => ({ ...v, is_default: v.id === g.id }))
                    .sort((a, b) => (b.is_default === true) - (a.is_default === true));
                // Guardar en localStorage
                localStorage.setItem('mi_garage', JSON.stringify(vehiclesActualizados));
                // Actualizar store para guest
                this.$store.commit('setGarageGuest', vehiclesActualizados);
            }

            // Opcional: actualizar vehículo seleccionado
            this.$store.dispatch("setVehiculoSeleccionado", {
                //year: g.year,
                marca: g.marca,
                // modelo: g.modelo,
                // motor: g.motor,
                //linea: g.linea
            });
        },
        applyGarageItem(g) {

            this.modelos = [];
            this.motores = [];
            this.lineas = [];

            //this.buscar2(g);
            this.closePanel();
        },
        buscar2(busqueda) {
            if (this.$store?.dispatch) this.$store.dispatch("resetBusquedaAvanzada");
            //this.$emit("cerrar-offcanvas");
            this.$router.push({
                name: "BusquedaAvanzada",
                query: {
                    year: busqueda.year,
                    marca: busqueda.marca,
                    modelo: busqueda.modelo,
                    motor: busqueda.motor || 0,
                    linea: busqueda.linea || 0,
                    idBusqueda: 0,
                    tipobusqueda: 0,
                    activoUsuario: 0
                }
            });
        },
        limpiarSeleccion() {
            // 1. Reset UI
            this.currentStep = 'menu';
            this.closeAllDropdowns();

            // 2. Limpiar selecciones
            this.selectedYear = null;
            this.selectedMarca = null;
            this.selectedModelo = null;
            this.selectedMotor = null;
            this.selectedLinea = null;

            // 3. Limpiar catálogos dependientes
            this.marcas = [];
            this.modelos = [];
            this.motores = [];
            this.lineas = [];

            // 4. Reset flags de carga
            this.isLoadingMarcas = false;
            this.isLoadingModelo = false;
            this.isLoadingMotor = false;
            this.isLoadingLineas = false;

            // 5. Cargar año actual y sus marcas
            this.setInitialYear();
        },
        confirmarEliminarVehiculo(vehiculo) {
            const esDefault = vehiculo.is_default === true;

            Swal.fire({
                icon: 'warning',
                title: 'Eliminar vehículo',
                html: esDefault
                    ? 'Este vehículo es tu <b>predefinido</b>.<br><br>¿Deseas eliminarlo?'
                    : '¿Deseas eliminar este vehículo?',
                showCancelButton: true,
                confirmButtonText: 'Eliminar',
                cancelButtonText: 'Cancelar',
                confirmButtonColor: '#dc3545'
            }).then(result => {
                if (result.isConfirmed) {
                    this.$store.dispatch('eliminarVehiculo', vehiculo);
                }
            });
        },
        seleccionarMedidas() {
            this.currentStep = 'form_medidas';  // cambiar step
            this.buscarmedidas();               // llamar al método para traer datos
        },

        async buscarmedidas() {
            try {
                const response = await axios.get('/catalogo/buscarmedidas'); // tu endpoint
                this.medidasLinea = []; // Limpiamos medidas anteriores
                this.medidaValores = {};
                this.lineasmedidas = response.data; // guardas resultado en data
            } catch (error) {
                console.error(error);
            }
        },
        resetearMedidas() {
            // 1. Limpiar los valores que el usuario seleccionó en los combos
            this.medidaValores = {};
            // 2. Restaurar las opciones dinámicas usando la copia original
            this.opcionesDinamicas = {};
            this.medidasLineaOriginales.forEach(medida => {
                this.opcionesDinamicas[medida.id] = medida.valores;
            });
            console.log("Filtros reseteados al estado inicial");
        },
        async seleccionarLineaMedidas(linea) {
            this.selectedLineaMedidas = linea;
            this.dropdownOpenLineaMedidas = false;

            try {
                const response = await axios.get(`/catalogo/buscarfiltrosmedidas/${linea.id}`);

                // 1. Guardas las definiciones de las medidas
                this.medidasLinea = response.data;

                // 2. Limpiar valores seleccionados
                this.medidaValores = {};
                this.medidasLineaOriginales = JSON.parse(JSON.stringify(response.data));
                // 3. Inicializar las opciones de cada select
                // En Vue 3, esto ya es reactivo automáticamente
                this.opcionesDinamicas = {};

                this.medidasLinea.forEach(medida => {
                    // Usamos los valores reales que vienen del servidor
                    this.opcionesDinamicas[medida.id] = medida.valores;
                });

            } catch (error) {
                console.error("Error al cargar medidas:", error);
            }
        },
        async actualizarOpcionesDependientes(idMedidaCambiado) {
            // Si el usuario deseleccionó (volvió al "-- Selecciona --"), 
            // podrías decidir si resetear todo o no enviar la petición.
            if (!this.medidaValores[idMedidaCambiado]) return;

            this.cargandoOpciones = true; // Empieza el bloqueo

            try {
                const response = await axios.post('/catalogo/actualizarOpcionesDependientes', {
                    linea_id: this.selectedLineaMedidas.id,
                    medida_cambiada_id: idMedidaCambiado,
                    filtros_acumulados: this.medidaValores
                });

                const nuevasOpciones = response.data;

                Object.keys(nuevasOpciones).forEach(id => {
                    if (id != idMedidaCambiado) {
                        this.opcionesDinamicas[id] = nuevasOpciones[id];

                        // Limpiar selección previa si ya no es válida
                        if (this.medidaValores[id] && !nuevasOpciones[id].includes(this.medidaValores[id])) {
                            this.medidaValores[id] = undefined;
                        }
                    }
                });

            } catch (error) {
                console.error("Error filtrando opciones:", error);
            } finally {
                this.cargandoOpciones = false; // Se libera el bloqueo, falle o funcione
            }
        },
        async buscarPorMedidas() {
            // 1. Validar que tengamos una línea seleccionada
            if (!this.selectedLineaMedidas) {
                alert("Por favor selecciona una línea primero");
                return;
            }

            // 2. Limpiar el objeto: enviar solo lo que tiene valor numérico
            const filtros = {};
            for (const idMedida in this.medidaValores) {
                const valor = this.medidaValores[idMedida];
                // Aseguramos que solo pasen valores válidos
                if (valor !== null && valor !== '' && !isNaN(valor)) {
                    filtros[idMedida] = valor;
                }
            }

            // 3. Validar que al menos escribió una medida
            if (Object.keys(filtros).length === 0) {
                alert("Ingresa al menos una medida para filtrar");
                return;
            }

            // 4. El PUSH hacia la nueva ruta
            // Usamos JSON.stringify para empaquetar los IDs y Valores
            this.$router.push({
                name: 'ResultadosBusquedaDimensiones', // Asegúrate que este nombre coincida con tu router/index.js
                query: {
                    linea: this.selectedLineaMedidas.id,
                    medidas: JSON.stringify(filtros)
                }
            });

            // Opcional: Cerrar el panel de búsqueda si es un modal o offcanvas
            if (this.panelOpen) {
                this.panelOpen = false;
            }
        }

    },

    mounted() {
        if (!this.isLoggedin && localStorage.getItem('garage_operativo')) {
            this.$store.dispatch('clearGarageOperativo');
        }
        axios.get(`/catalogo/catalogocompletemountedNuevo`)
            .then(res => {
                this.years = res.data.anios || [];
                this.marcas = res.data.marcas || [];
                this.busqueda = res.data.busqueda || [];
                this.selectedYear = this.years[0] || null;
            });

        //this.loadGarageFromStorage();

        document.addEventListener("click", this.handleClickOutside);
        document.addEventListener("keydown", e => {
            if (e.key === "Escape") this.closePanel();
        });

    },

    beforeUnmount() {
        document.removeEventListener("click", this.handleClickOutside);
    }
};
</script>


<style scoped>
/* 1. ESTRUCTURA Y POSICIONAMIENTO */
.busqueda-avanzada-component {
    position: relative;
}

#modalBusquedaVehiculo {
    position: absolute !important;
    top: 100% !important;
    left: 0 !important;
    width: auto;
    height: auto;
    overflow: visible;
}

.modal-debajo-boton {
    margin: 5px 0 0 0 !important;
    width: 580px;
    max-width: 95vw;
    max-height: calc(100vh - 80px);
    pointer-events: auto;
}

.modal-debajo-boton .modal-content {
    max-height: calc(100vh - 80px);
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.modal-debajo-boton .modal-body {
    overflow-y: auto;
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: 16px !important;
}

.modal-debajo-boton h5 {
    font-size: 0.9rem !important;
    margin-bottom: 4px !important;
}

.modal-debajo-boton p.small {
    margin-bottom: 8px !important;
}

.modal-debajo-boton .mb-3.d-flex {
    margin-bottom: 8px !important;
}

.modal.fade .modal-dialog.modal-debajo-boton {
    transform: none !important;
    transition: opacity 0.15s linear;
}

/* 2. BOTÓN PRINCIPAL */
.btn-vehiculo {
    background: transparent;
    color: #fff;
    border-radius: 8px;
    font-size: 0.85rem;
    padding: 6px 12px;
}

/* 3. DROPDOWNS COMPACTOS */
.dropdown-btn {
    width: 100%;
    background: #0b3650;
    color: #ffffff;
    border: 1px solid rgba(255, 210, 122, 0.2);
    border-radius: 8px;
    padding: 0.5rem 0.7rem;
    font-size: 0.85rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
}

.dropdown-btn:hover {
    border-color: #ffd27a;
}

.dropdown-btn .arrow {
    color: #ffd27a;
}

.dropdown-filter-item {
    pointer-events: all;
    cursor: default;
}

.dropdown-filter-item:hover {
    background: transparent !important;
}

.dropdown-menu-custom {
    position: absolute;
    width: 100%;
    box-sizing: border-box;
    max-height: 200px;
    overflow-y: auto;
    margin-top: 1px;
    margin-bottom: 1px;
    border: 1px solid #ffd27a;
    border-radius: 8px;
    background: #06283c;
    z-index: 5000;
    list-style: none;
    padding: 4px;
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.5);
    font-size: 0.85rem;
    left: 0;
}

.dropdown-item {
    padding: 0.4rem 0.7rem;
    cursor: pointer;
    border-radius: 4px;
    color: #ffffff;
}

.dropdown-item:hover {
    background: #ffd27a;
    color: #06283c;
}

/* 4. TARJETAS OPCIONES */
.search-option-card {
    background: #0b3650;
    border: 1px solid rgba(255, 210, 122, 0.2);
    border-radius: 10px;
    cursor: pointer;
    display: flex;
    align-items: center;
    padding: 8px 12px !important;
    gap: 10px;
    transition: all 0.2s ease;
}

.search-option-card:hover {
    transform: translateY(-2px);
    border-color: #ffd27a;
}

.search-option-card .icon-box-dark {
    width: 32px;
    height: 32px;
    background: #06283c;
    color: #ffd27a;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.1rem;
    border: 1px solid rgba(255, 210, 122, 0.1);
}

.search-option-card span {
    color: #ffd27a;
    font-weight: 600;
    font-size: 0.8rem;
}

/* 5. GARAGE */
.garage-item-card {
    position: relative;
    background: rgba(255, 255, 255, 0.04);
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 10px;
    padding: 8px !important;
    margin-bottom: 6px !important;
}

.garage-icon {
    width: 32px;
    height: 32px;
    background: #1a1a1a;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #f39c12;
    font-size: 1rem;
}

.btn-select-garage {
    background: #f39c12;
    border: none;
    color: white;
    font-size: 0.7rem;
    padding: 2px 8px;
    font-weight: bold;
    border-radius: 5px;
}

.btn-delete-garage {
    position: absolute;
    top: 5px;
    right: 8px;
    background: transparent;
    border: none;
    color: #666;
    font-size: 1rem;
}

/* 6. BOTONES ACCIÓN */
.btn-apply-orange {
    background: #f39c12;
    color: #06283c;
    text-transform: uppercase;
    font-weight: 800;
    font-size: 0.8rem;
    border: none;
    border-radius: 8px;
    padding: 8px !important;
    width: 100%;
}

.vehiculo-actions {
    flex-shrink: 0;
    padding-top: 8px;
    background: #06283c;
    border-top: 1px solid rgba(255, 210, 122, 0.1);
    margin-top: 8px;
}

/* 7. GENERALES */
.input-measure-dark {
    background: #0b3650;
    border: 1px solid #ffd27a;
    border-radius: 6px;
    color: #ffd27a;
    font-weight: bold;
    font-size: 0.85rem;
    padding: 6px;
}

.bg-dark-app {
    background-color: #06283c !important;
}

.x-small {
    font-size: 11px;
}

/* 8. SCROLLBARS */
.garage-scroll-container::-webkit-scrollbar {
    width: 4px;
}

.garage-scroll-container::-webkit-scrollbar-thumb {
    background: #444;
    border-radius: 10px;
}

.garage-scroll-vertical::-webkit-scrollbar {
    width: 4px;
}

.garage-scroll-vertical::-webkit-scrollbar-thumb {
    background: #f39c12;
    border-radius: 10px;
}

.dropdown-menu-custom::-webkit-scrollbar {
    width: 6px;
}

.dropdown-menu-custom::-webkit-scrollbar-thumb {
    background: #f39c12;
    border-radius: 10px;
}

.dropdown-menu-custom::-webkit-scrollbar-track {
    background: #06283c;
}

/* 9. SHIMMER */
.skeleton-line {
    height: 8px;
    background: linear-gradient(90deg, #0b3650, #164a6d, #0b3650);
    background-size: 200% 100%;
    animation: shimmer 1.2s infinite linear;
    border-radius: 4px;
}

@keyframes shimmer {
    0% {
        background-position: -200% 0;
    }

    100% {
        background-position: 200% 0;
    }
}

/* Botón con valor seleccionado */
.hfield-btn.has-value span {
    color: #ffd27a;
    font-weight: 600;
}

/* Botón sin valor (Motor, Línea vacíos) */
.hfield-btn:not(.has-value) span {
    font-weight: 700;
}

/* 10. MEDIDAS */
.measure-option-card {
    background: #2b2b2b;
    color: white;
    padding: 10px 15px;
    border-radius: 8px;
    border: 1px solid #444;
    cursor: pointer;
    transition: all 0.2s ease;
    min-width: 60px;
    text-align: center;
    font-size: 0.9rem;
}

.measure-option-card:hover {
    border-color: #ff6600;
}

.measure-option-card.active {
    background: #ff6600;
    border-color: #ff6600;
    color: white;
    font-weight: bold;
    box-shadow: 0 0 10px rgba(255, 102, 0, 0.3);
}

.input-measure-dark {
    background-color: #1e1e1e !important;
    color: white !important;
    border: 1px solid #333 !important;
    padding: 12px !important;
    border-radius: 8px !important;
    appearance: none;
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23ff6600' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/%3e%3c/svg%3e");
    background-repeat: no-repeat;
    background-position: right 1rem center;
    background-size: 16px 12px;
}

.input-measure-dark:focus {
    border-color: #ff6600 !important;
    box-shadow: 0 0 0 0.25rem rgba(255, 102, 0, 0.25) !important;
    outline: none;
}

.input-measure-dark option {
    background-color: #1e1e1e;
    color: white;
}

.dropdown-wrapper.dropup .dropdown-menu-custom {
    bottom: 100%;
    top: auto;
    margin-bottom: 1px;
    margin-top: 2px;
}

/* 11. LAYOUT HORIZONTAL VEHICULO */
.vehiculo-layout-horizontal {
    display: flex;
    gap: 0;
    flex: 1;
    border: 1px solid rgba(255, 210, 122, 0.15);
    border-radius: 12px;
    overflow: hidden;
}

.vehiculo-col-left {
    width: 160px;
    min-width: 160px;
    background: #071f2e;
    border-right: 1px solid rgba(255, 210, 122, 0.15);
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.vehiculo-col-right {
    flex: 1;
    background: #06283c;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.hfield-label {
    display: none;
}

.hfield-row {
    padding: 2px 2px;
}

.hfield-btn {
    background: transparent;
    border: 1px solid transparent;
    border-radius: 8px;
    color: #fff;
    font-size: 0.8rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    transition: all 0.15s ease;
    text-align: left;
    gap: 4px;
    width: 100%;
}

.hfield-btn span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    flex: 1;
}

.hfield-btn i {
    color: rgba(255, 210, 122, 0.5);
    font-size: 0.9rem;
    flex-shrink: 0;
    transition: color 0.15s;
}

.hfield-btn:hover {
    background: rgba(255, 210, 122, 0.08);
    border-color: rgba(255, 210, 122, 0.2);
}

.hfield-btn:disabled {
    opacity: 0.35;
    cursor: not-allowed;
}

.hfield-row.active .hfield-btn {
    background: rgba(255, 210, 122, 0.12);
    border-color: #ffd27a;
    color: #ffd27a;
}

.hfield-row.active .hfield-btn i {
    color: #ffd27a;
}

.hpanel-search {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 12px;
    border-bottom: 1px solid rgba(255, 210, 122, 0.1);
    background: #071f2e;
    flex-shrink: 0;
}

.hpanel-search i {
    color: rgba(255, 210, 122, 0.5);
    font-size: 1rem;
    flex-shrink: 0;
}

.hpanel-search input {
    background: transparent;
    border: none;
    outline: none;
    color: #fff;
    font-size: 0.82rem;
    width: 100%;
}

.hpanel-search input::placeholder {
    color: rgba(255, 255, 255, 0.3);
}

.hpanel-list {
    list-style: none;
    margin: 0;
    padding: 6px;
    overflow-y: auto;
    flex: 1;
    max-height: 280px;
}

.hpanel-list::-webkit-scrollbar {
    width: 4px;
}

.hpanel-list::-webkit-scrollbar-thumb {
    background: #f39c12;
    border-radius: 10px;
}

.hpanel-list::-webkit-scrollbar-track {
    background: transparent;
}

.hpanel-item {
    display: flex;
    align-items: center;
    padding: 7px 10px;
    border-radius: 6px;
    font-size: 0.82rem;
    color: #fff;
    cursor: pointer;
    transition: background 0.12s;
}

.hpanel-item:hover {
    background: rgba(255, 210, 122, 0.1);
}

.hpanel-item.selected {
    background: rgba(255, 210, 122, 0.18);
    color: #ffd27a;
    font-weight: 600;
}

.hpanel-item.selected i {
    color: #ffd27a;
}

.hpanel-empty-item {
    padding: 12px 10px;
    font-size: 0.8rem;
    color: rgba(255, 255, 255, 0.35);
    text-align: center;
}

.hpanel-empty {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 20px;
}

/* 12. GLOBAL MODAL */
.modal-backdrop.show {
    backdrop-filter: blur(6px);
    background-color: rgba(0, 0, 0, 0.8);
}

#modalBusquedaVehiculo .modal-content {
    border: 1px solid rgba(255, 210, 122, 0.2);
}

/* 13. MEDIA QUERIES */

/* MÓVIL VERTICAL */
@media (max-width: 767.98px) and (orientation: portrait) {
    .modal-debajo-boton {
        position: fixed !important;
        top: 60px;
        left: 0;
        right: 0;
        width: 95%;
        max-width: 95%;
        max-height: calc(100vh - 70px);
        margin: 0 auto;
        border-radius: 15px;
        overflow: hidden;
        box-shadow: 0 8px 20px rgba(0, 0, 0, 0.5);
        z-index: 5000;
    }

    .busqueda-avanzada-component {
        overflow: visible;
    }
}

/* LANDSCAPE / PANTALLA CORTA (915x412, tablets landscape, etc) */
/* Reemplaza o agrega en el media query @media (max-height: 500px) */
@media (max-height: 500px) {
    .modal-debajo-boton {
        position: fixed !important;
        top: 55px;
        left: 10px;
        width: 580px !important;
        max-width: calc(100vw - 20px);
        max-height: calc(100vh - 65px);
        margin: 0 !important;
    }

    .modal-debajo-boton .modal-content {
        max-height: calc(100vh - 65px);
    }

    /* ← ESTO es lo que falta: limitar el layout horizontal */
    .vehiculo-layout-horizontal {
        max-height: calc(100vh - 210px);
        /* deja espacio al header y botones */
        overflow: hidden;
    }

    /* ← Y la lista interna que no se desborde */
    .hpanel-list {
        max-height: calc(100vh - 260px);
        overflow-y: auto;
    }

    .vehiculo-col-left {
        overflow-y: auto;
    }

    .modal-debajo-boton h5 {
        font-size: 0.8rem !important;
        margin-bottom: 2px !important;
    }

    .modal-debajo-boton p.small {
        display: none;
    }

    .modal-debajo-boton .modal-body {
        padding: 10px !important;
    }

    .vehiculo-actions {
        padding-top: 6px;
        margin-top: 6px;
    }

    .btn-apply-orange {
        padding: 6px !important;
        font-size: 0.75rem !important;
    }
}

/* DESKTOP NORMAL */
@media (min-width: 992px) and (min-height: 501px) {
    .modal-debajo-boton {
        width: 580px !important;
        max-height: calc(100vh - 80px);
    }

    :deep(.modal-backdrop) {
        display: none !important;
    }
}
</style>